module.exports = __webpack_public_path__ + "img/honer15.b357666d.jpg";